export class SortConstants {
  public static ASC = 'asc';
  public static DESC = 'desc';
}
